import React from 'react';
import ApplyLoan from '../components/apply-loan';

const ApplyLoanPage = () => {
  return <ApplyLoan />;
};

export default ApplyLoanPage;
